import React, { useState } from 'react'
import { Modal } from '@/components/ui/Modal'
import { Input } from '@/components/ui/Input'

interface CreateViewModalProps {
  onClose: () => void
  onConfirm: (title: string) => void
  existingViews: string[]
}

export const CreateViewModal: React.FC<CreateViewModalProps> = ({
  onClose,
  onConfirm,
  existingViews,
}) => {
  const [viewName, setViewName] = useState('')
  const [error, setError] = useState('')

  const handleConfirm = () => {
    if (!viewName.trim()) {
      setError('Le nom de la vue est requis')
      return
    }

    if (existingViews.includes(viewName.trim())) {
      setError('Une vue avec ce nom existe déjà')
      return
    }

    onConfirm(viewName.trim())
  }

  return (
    <Modal
      title="Créer une nouvelle vue"
      confirmButtonText="Créer"
      onCancel={onClose}
      onConfirm={handleConfirm}
      size="sm"
    >
      <div className="space-y-4">
        <Input
          label="Nom de la vue"
          value={viewName}
          onChange={(e) => {
            setViewName(e.target.value)
            setError('')
          }}
          error={error}
          placeholder="Entrez le nom de la vue"
          autoFocus
        />
      </div>
    </Modal>
  )
}


